var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isHeader)?_c('p',{style:(_vm.tmpTheme)},[_vm._v("购物车"),_c('span',{attrs:{"id":"topcartnum"}},[_vm._v("("+_vm._s(_vm.getLogin?_vm.totals:'0')+")")])]):_c('p',{staticClass:"cartCount",style:(_vm.tmpTheme),attrs:{"id":"rightcartnum"}},[_vm._v(_vm._s(_vm.totals?_vm.totals:'0'))])
}
var staticRenderFns = []

export { render, staticRenderFns }